import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent, DialogContentText, DialogTitle, DialogActions
} from '@mui/material';
import WarningOutlinedIcon from '@mui/icons-material/WarningOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { AppRootState } from '../../app/store';
import { useNavigate } from 'react-router-dom';
import { isLinkValidType } from './auth-reducer';

type AlertLinkPropsType = {


  
 
}

export const AlarmLinkNotValid = (props: AlertLinkPropsType) => {
  const navigate = useNavigate()
  const isLinkValid = useSelector<AppRootState, isLinkValidType>(state => state.auth.isResetLinkValid)
  
  const handleCloseOnOK = () => {
    navigate('/login')
  }

  return (
    <Dialog
    open={isLinkValid === false}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title" style={{display: "flex", alignItems: "center", marginRight:'50px'}}>
      <WarningOutlinedIcon color="warning" fontSize='large' style={{paddingRight: '14px' }}/>
      {" "}
      {"The link is not valid! "}
       
    </DialogTitle>
    <DialogActions>
      <Button onClick={handleCloseOnOK} variant="contained" color="info"  autoFocus>
        OK
      </Button>
    </DialogActions>
  </Dialog>
  )
}